import { PrepaySearchModel } from '@app/models/myoffice/prepay/prepay-search.model';
import { ResultProc } from '@app/models/system/result-proc.model';
import { createAction, props } from '@ngrx/store';

// save prepay
export const savePrepay = createAction(
    "[Prepay Register API] save prepay",
    props<{ params: any }>()
);
  
export const savePrepaySuccess = createAction(
    "[Prepay Register API] save prepay success",
    props<{ result: ResultProc }>()
);
  
export const savePrepayFailure = createAction(
    "[Prepay Register API] save prepay failure",
    props<{ msg: any }>()
);

// search
export const searchPrepay = createAction(
    "[Prepay API] search prepay",
    props<{ params: any }>()
);
  
export const searchPrepaySuccess = createAction(
    "[Prepay API] search prepay success",
    props<{ prepay: PrepaySearchModel[] }>()
);
  
export const searchPrepayFailure = createAction(
    "[Prepay API] search prepay failure",
    props<{ msg: any }>()
);

// count
export const countPrepay = createAction(
    "[Prepay API] count prepay",
    props<{ params: any }>()
);
  
export const countPrepaySuccess = createAction(
    "[Prepay API] count prepay success",
    props<{ count: Number }>()
);
  
export const countPrepayFailure = createAction(
    "[Prepay API] count prepay failure",
    props<{ msg: any }>()
);

// sum
export const sumPrepay = createAction(
    "[Prepay API] sum prepay",
    props<{ params: any }>()
);
  
export const sumPrepaySuccess = createAction(
    "[Prepay API] sum prepay success",
    props<{ sum: PrepaySearchModel }>()
);
  
export const sumPrepayFailure = createAction(
    "[Prepay API] sum prepay failure",
    props<{ msg: any }>()
);

// search prepay details
export const searchPrepayDetails = createAction(
    "[Prepay API] search prepay details",
    props<{ params: any }>()
);
  
export const searchPrepayDetailsSuccess = createAction(
    "[Prepay API] search prepay details success",
    props<{ prepay: PrepaySearchModel[] }>()
);
  
export const searchPrepayDetailsFailure = createAction(
    "[Prepay API] search prepay details failure",
    props<{ msg: any }>()
);

// count
export const countPrepayDetails = createAction(
    "[Prepay API] count prepay details",
    props<{ params: any }>()
);
  
export const countPrepayDetailsSuccess = createAction(
    "[Prepay API] count prepay details success",
    props<{ count: Number }>()
);
  
export const countPrepayDetailsFailure = createAction(
    "[Prepay API] count prepay details failure",
    props<{ msg: any }>()
);

// sum
export const sumPrepayDetails = createAction(
    "[Prepay API] sum prepay details",
    props<{ params: any }>()
);
  
export const sumPrepayDetailsSuccess = createAction(
    "[Prepay API] sum prepay details success",
    props<{ sum: PrepaySearchModel }>()
);
  
export const sumPrepayDetailsFailure = createAction(
    "[Prepay API] sum prepay details failure",
    props<{ msg: any }>()
);

// search prepay details by Userid
export const searchPrepayDetailsId = createAction(
    "[Prepay API] search prepay details by userid",
    props<{ userid: String }>()
);
  
export const searchPrepayDetailsIdSuccess = createAction(
    "[Prepay API] search prepay details by userid success",
    props<{ prepay: PrepaySearchModel[] }>()
);
  
export const searchPrepayDetailsIdFailure = createAction(
    "[Prepay API] search prepay details by userid failure",
    props<{ msg: any }>()
);


// delete prepay
export const deletePrepay = createAction(
    "[Prepay Register API] delete prepay",
    props<{ userid:string, moneyno:string}>()
);
  
export const deletePrepaySuccess = createAction(
    "[Prepay Register API] delete prepay success",
    props<{ result: ResultProc }>()
);
  
export const deletePrepayFailure = createAction(
    "[Prepay Register API] delete prepay failure",
    props<{ msg: any }>()
);

export const setDeletePrepay = createAction(
    "[Prepay Register API] set delete prepay result",
    props<{ deleteResult: ResultProc }>()
);